var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2846 1.40434C10.2846 0.75524 11.1223 0.423644 11.6256 0.873548L15.6579 4.47823L15.6599 4.48001C16.1147 4.89611 16.1147 5.58074 15.6599 5.99685L15.657 5.99949L11.6273 9.62323C11.1247 10.0753 10.2846 9.7441 10.2846 9.09395V7.57631C7.66638 7.57631 4.91677 7.9731 3.48604 10.7205C3.38906 10.9067 3.07057 10.8385 3.08652 10.6292C3.57208 4.25549 8.13369 3.2823 10.2846 2.92418V1.40434Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.51745C0 1.49524 0.828589 0.666504 1.85088 0.666504H6.80083C7.14158 0.666504 7.41781 0.942736 7.41781 1.28349C7.41781 1.62424 7.14158 1.90047 6.80083 1.90047H1.85088C1.51017 1.90047 1.23396 2.17666 1.23396 2.51745V13.6231C1.23396 13.9639 1.5102 14.2401 1.85095 14.2401H12.9566C13.2974 14.2401 13.5736 13.9639 13.5736 13.6231V10.4309C13.5736 10.0902 13.8498 9.81394 14.1906 9.81394C14.5313 9.81394 14.8076 10.0902 14.8076 10.4309V13.6231C14.8076 14.6454 13.9789 15.4741 12.9566 15.4741H1.85095C0.828697 15.4741 0 14.6454 0 13.6231V2.51745Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.bbb398c8.svg";
export { ForwardRef as ReactComponent };